import { createI18n } from 'vue-i18n'

import en from '~/locales/en.json'
import zh from '~/locales/zh.json'

export type LocaleCode = 'en-US' | 'zh-CN'

const DEFAULT_LOCALE: LocaleCode = 'en-US'
const LOCALE_STORAGE_KEY = 'locale-store'

function getInitialLocale(): LocaleCode {
  if (typeof window === 'undefined')
    return DEFAULT_LOCALE

  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY)
    if (!stored)
      return DEFAULT_LOCALE

    const parsed = JSON.parse(stored) as { locale?: LocaleCode }
    return parsed.locale === 'zh-CN' || parsed.locale === 'en-US'
      ? parsed.locale
      : DEFAULT_LOCALE
  }
  catch {
    return DEFAULT_LOCALE
  }
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    'en-US': en,
    'zh-CN': zh,
  },
})
